import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl, ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-form-errors',
  templateUrl: './form-errors.component.html',
  styleUrls: ['./form-errors.component.css']
})
export class FormErrorsComponent {

  @Input({required: true}) control!: AbstractControl | null;
  @Input() fieldName: string = 'This field'; // Optional, can be overridden

  get errorMessages(): string[] {
    if (!this.control || !this.control.errors || !this.control.touched) {
      return [];
    }
    return this.getErrorMessages(this.control.errors);
  }

  get hasErrors(): boolean {
    return !!(this.control?.touched && !!this.control?.errors);
  }

  private getErrorMessages(errors: ValidationErrors): string[] {
    const messages: string[] = [];

    if (errors['required']) {
      messages.push(`${this.fieldName} is required.`);
      
    }
    if (errors['nonZero']) {
      messages.push(`${this.fieldName} cannot be zero.`);
    }
    if (errors['minlength']) {
      messages.push(
        `Minlength: ${errors['minlength'].requiredLength} required.`
      );
    }
    if (errors['maxlength']) {
      messages.push(
        `${this.fieldName} must be at most ${errors['maxlength'].requiredLength} characters long.`
      );
    }
    if(errors['invalidName']){
      messages.push(`Only alphabets and spaces are allowed.`);
    }
    if (errors['email']) {
      messages.push(`Please enter a valid email.`);
    }
    if (errors['pattern']) {
      messages.push(`Invalid format.`);
    }
    if (errors['startDateAfterEndDate']) {
      messages.push(`${this.fieldName} cannot be after the end date.`);
    }

    if (errors['endDateBeforeStartDate']) {
      messages.push(`${this.fieldName} cannot be before the start date.`);
    }
    
    if (errors['invalidMobile']) {
      messages.push(`Enter valid mobile number.`);
    }

    if(errors['whitespace']){
      messages.push('No empty spaces allowed!')
    }

    if (errors['invalidPhone']) {
      console.log('MOBILE VALIDATOR ERROR');

      const message = typeof errors['invalidPhone'] === 'object' && errors['invalidPhone'].message
        ? errors['invalidPhone'].message
        : `Invalid phone or landline number.`;
      messages.push(message);
    }

    if (errors['noFutureDate']) {
      messages.push(`${this.fieldName} cannot be a future date.`);
    }

    if (errors['noPastDate']) {
      messages.push(`${this.fieldName} cannot be a past date.`);
    }

    if (errors['invalidYear']) {
      messages.push(`${this.fieldName} must have a valid 4-digit year.`);
    }

    return messages;
  }

}
